angular
	.module 'App.Repository'
	.factory 'ShopTableRepository', ['BaseRepository', (BaseRepository) ->
		class ShopTableRepository extends BaseRepository
			@resource = '/shop_tables'
			@isRestricted = true

		return new ShopTableRepository
	]
